import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftAlert from "components/SoftAlert";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ApiService from "services/ApiService";
import ToastUtils from "utils/ToastUtils";
import { useNavigate, useParams } from "react-router-dom";
import _ from "lodash";
import ValidationService from "services/ValidationService";
import Helpers from "utils/Helpers";
import Input from "components/CustomFields/Input";
import RoleSelect from "components/CustomFields/RolesSelect";
import YesNoSelect from "components/CustomFields/YesNoSelect";

function UsersEdit() {
  const [showInfoAlert, setShowInfoAlert] = useState(false);
  const [alertInfoText, setAlertInfoText] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [roleId, setRoleId] = useState(null);
  const [verifiedEmail, setVerifiedEmail] = useState(false);
  const [verifiedPhone, setVerifiedPhone] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const { id } = useParams();

  const navigate = useNavigate();

  const handleVerifiedEmail = (val) => setVerifiedEmail(val === 1);
  const handleVerifiedPhone = (val) => setVerifiedPhone(val === 1);
  const handleDisabled = (val) => setDisabled(val === 1);

  const updateUser = async () => {
    setShowInfoAlert(false);
    const user = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
      roleId: roleId,
      emailVerified: verifiedEmail,
      phoneVerified: verifiedPhone,
      disabled: disabled,
    };

    const error = ValidationService.validateFullUser(user);

    if (error) {
      setAlertInfoText(error.message);
      setShowInfoAlert(true);
      return;
    }

    const response = await ApiService.putData(`/api/v1/users/${id}`, user);
    if (!response) {
      ToastUtils.error(`Αδυναμία επεξεργασίας χρήστη!`);
      return;
    }

    ToastUtils.success("Επιτυχία επεξεργασίας χρήστη!");
    navigate("/users/users-list");
  };

  const fetchUserData = async () => {
    const userData = await ApiService.getData(`/api/v1/users/${id}`);
    if (!userData) {
      ToastUtils.error("Αδυναμία εύρεσης δεδομένων χρήστη!");
      return;
    }

    setFirstName(_.get(userData.data, "firstName"));
    setLastName(_.get(userData.data, "lastName"));
    setEmail(_.get(userData.data, "email"));
    setPhone(_.get(userData.data, "phone"));
    setRoleId(_.get(userData.data, "role.id"));
    setDisabled(_.get(userData.data, "disabled"));
    setVerifiedEmail(_.get(userData.data, "emailVerified"));
    setVerifiedPhone(_.get(userData.data, "phoneVerified"));
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mt={3} mb={4}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
            <Card sx={{ overflow: "visible" }}>
              <SoftBox p={2} lineHeight={1}>
                <SoftTypography variant="h6" fontWeight="medium">
                  Επεξεργασία στοιχείων χρήστη
                </SoftTypography>
                <SoftTypography variant="button" fontWeight="regular" color="text">
                  Επεξεργαστείτε τα στοιχεία του χρήστη στην παρακάτω φόρμα.
                </SoftTypography>
                <Divider />
                {showInfoAlert && (
                  <SoftAlert color="error" dismissible show={showInfoAlert}>
                    {alertInfoText}
                  </SoftAlert>
                )}
                <Grid container spacing={3}>
                  <Input
                    title="Όνομα"
                    xs={12}
                    md={6}
                    handler={setFirstName}
                    initialValue={firstName}
                  />
                  <Input
                    title="Επώνυμο"
                    xs={12}
                    md={6}
                    handler={setLastName}
                    initialValue={lastName}
                  />
                </Grid>
                <Grid container spacing={3}>
                  <Input title="Email" xs={12} md={6} handler={setEmail} initialValue={email} />
                  <Input title="Τηλέφωνο" xs={12} md={6} handler={setPhone} initialValue={phone} />
                </Grid>
                <Grid container spacing={3}>
                  <RoleSelect xs={12} md={3} handler={setRoleId} initialValue={roleId} />
                  <YesNoSelect
                    title={"Επαληθευμένο Email?"}
                    xs={12}
                    md={3}
                    handler={handleVerifiedEmail}
                    initialValue={verifiedEmail}
                  />{" "}
                  <YesNoSelect
                    title={"Επαληθευμένο Τηλέφωνο?"}
                    xs={12}
                    md={3}
                    handler={handleVerifiedPhone}
                    initialValue={verifiedPhone}
                  />
                  <YesNoSelect
                    title={"Ανενεργός?"}
                    xs={12}
                    md={3}
                    handler={handleDisabled}
                    initialValue={disabled}
                  />
                </Grid>

                <SoftBox display="flex" justifyContent="flex-end" mt={3}>
                  <SoftButton
                    variant="gradient"
                    color="info"
                    style={{ width: "100%" }}
                    onClick={updateUser}
                  >
                    ΕΠΕΞΕΡΓΑΣΙΑ
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </Card>
          </Grid>
        </Grid>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default UsersEdit;
